var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-to",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c10000",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h250v200.3H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c10000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.8 31.2h39.9v139.6h-39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6 81v40H53V81z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/to.a7375d4d.svg";
export { ForwardRef as ReactComponent };